"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var storage_1 = __importDefault(require("./storage"));
var clientInfo_1 = __importDefault(require("./clientInfo"));
var AUTH_REQUEST_ENDPOINT = 'auth/login/request';
var AUTH_VALIDATION_ENDPOINT = 'auth/login/validate';
var AUTH_LOGOUT_ENDPOINT = 'auth/logout';
var REGISTER = 'auth/register';
var endpointMerge = function (institution, endpoint) {
    return "https://apiv2.".concat(institution, ".aula.education/").concat(endpoint);
};
var AulaAuth = /** @class */ (function () {
    function AulaAuth() {
        this.storage = new storage_1.default();
        this.client = new clientInfo_1.default();
    }
    AulaAuth.prototype.requestLoginResend = function (email, institution) {
        return axios_1.default.post(endpointMerge(institution, AUTH_REQUEST_ENDPOINT), {
            email: email,
            resend: true,
        });
    };
    AulaAuth.prototype.requestLogin = function (email, institution, redirectApp) {
        if (redirectApp === void 0) { redirectApp = 'app'; }
        return axios_1.default.post(endpointMerge(institution, AUTH_REQUEST_ENDPOINT), {
            email: email,
            redirectApp: redirectApp,
        });
    };
    AulaAuth.prototype.validateCode = function (code, institution, email) {
        var _this = this;
        return this.client.getUniqueDeviceId().then(function (deviceId) {
            return axios_1.default
                .post(endpointMerge(institution, AUTH_VALIDATION_ENDPOINT), {
                code: code,
                email: email,
                deviceId: deviceId,
                deviceData: {
                    os: "".concat(_this.client.getInfo().os.name, " - ").concat(_this.client.getInfo().os.version),
                    platform: 'web',
                },
            }, { withCredentials: true })
                .then(function (response) {
                _this.storage.set(response.data.token, institution, email);
                return response.data.token;
            });
        });
    };
    AulaAuth.prototype.registerUser = function (institution, user) {
        return axios_1.default.post(endpointMerge(institution, REGISTER), user);
    };
    AulaAuth.prototype.getSession = function (institution, email) {
        return this.storage.getSession(institution, email);
    };
    AulaAuth.prototype.getDomains = function (email) {
        return this.storage.getDomains(email);
    };
    AulaAuth.prototype.getLoggedInUsers = function () {
        return this.storage.getLoggedInUsers();
    };
    AulaAuth.prototype.setActiveDomain = function (domain, email) {
        return this.storage.setActiveDomain(domain, email);
    };
    AulaAuth.prototype.getActiveUserInDomain = function (domain) {
        return this.storage.getActiveUserInDomain(domain);
    };
    AulaAuth.prototype.setLoggedOut = function (domain, email) {
        return this.storage.setLoggedOut(domain, email);
    };
    AulaAuth.prototype.requestLogout = function (sessionToken, email, institution) {
        this.setLoggedOut(institution, email);
        return this.client.getUniqueDeviceId().then(function (deviceId) {
            return axios_1.default.post(endpointMerge(institution, AUTH_LOGOUT_ENDPOINT), {
                sessionToken: sessionToken,
                email: email,
                deviceId: deviceId,
            }, { withCredentials: true });
        });
    };
    AulaAuth.prototype.getSSOCookie = function () {
        return this.storage.getSSOCookie();
    };
    AulaAuth.prototype.setToken = function (session, domain, email) {
        return this.storage.set(session, domain, email);
    };
    AulaAuth.prototype.deleteSSOCookie = function () {
        return this.storage.deleteSSOCookie();
    };
    return AulaAuth;
}());
exports.default = AulaAuth;
